import {Module} from "../common/Module";
import {isPrivileged} from "../../config/Privileges";
import {TimesheetAreaName} from "./Timesheet";
import {SoftDeletable} from "../common/SoftDeletable";
import {Identifier} from "../common/Identifier";
import {TimesheetTaskId} from "./TimesheetTask";


export const TimesheetTaskPredefinedDescriptionModule: Module = {
    identifier: "tasks_descriptions",
    isPrivileged: ( authUser, privilege) =>  isPrivileged( authUser, TimesheetAreaName, TimesheetTaskPredefinedDescriptionModule.identifier, privilege )
};

/**
 * route for async select component to fetch entries
 *
 * @param taskId
 */
export function timesheetTaskDesciptionSelectRoute( taskId: number = 0 ): string {
    return `timesheet/tasks/${taskId}/descriptions/select`;
}

export interface TimesheetTaskPredefinedDescriptionId {
    taskDescriptionId: Identifier<number>
}

export interface TimesheetTaskPredefinedDescription extends TimesheetTaskId, TimesheetTaskPredefinedDescriptionId, SoftDeletable {
    description: string
}

export interface TimesheetTaskPredefinedDescriptionProp {
    preDefDescription: TimesheetTaskPredefinedDescription
}

export interface TimesheetTaskPredefinedDescriptionListProp {
    preDefDescriptionList: TimesheetTaskPredefinedDescription[]
}